import store from "store";

const prefix = "scalene";
const get = key => store.get(`${prefix}:${key}`);
const set = (key, val) => store.set(`${prefix}:${key}`, val);
const rem = key => store.remove(`${prefix}:${key}`);

export { get, set, rem };
